module.exports = __webpack_public_path__ + "img/pickOne.ffe44386.png";